var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("pͪoͣnͬpͣoͥnͭpͣa͡inͥ を支える技術")]),_c('DraggableText')],1)}
var staticRenderFns = []

export { render, staticRenderFns }